import { ActionContext } from 'vuex';
import {ListStateItem, ListModuleItem} from '@/store/shared/index'
import LogisticsCost from './entity'
import {$http} from '@/lib'
import {PageResult} from '@/store/shared/entity';
import { State } from 'vuex-class';

//定义 interface  常用情况 edit页面entity  codelist等   页面需要的数据对象都要在此声明
interface LogisticsCostState extends ListStateItem<LogisticsCost>{
    editLogisticsCost: LogisticsCost;
    securityItem: any;
    allTotal:number;
}

class LogisticsCostModule extends ListModuleItem<LogisticsCostState,any,LogisticsCost>{

    //构造函数 （必须）将派生类中 的overrideState 和 overrideMutations 与基类（ListModuleItem）中的state mutations合并
    constructor() {
        super();
        Object.assign(this.state, this.overrideState);
        Object.assign(this.mutations, this.overrideMutations);
    }
    
    //state  页面需要的数据对象都要在此实例化  
    overrideState = {
        editLogisticsCost: new LogisticsCost(),
        securityItem: {},
        allTotal:null,
    }

    //action中 function 都是异步
    actions = {
   
        //分页查询
        async getAll(context: ActionContext<LogisticsCostState, any>, payload: any) {
            context.state.table.loading=true;
            let reponse = await $http.get('/services/app/LogisticsCost/GetAllLogisticsCost', { params: payload.data });
            context.state.table.loading=false;
            let page = reponse.data.result as PageResult<LogisticsCost>;
            context.state.table.totalCount=page.totalCount;
            context.state.table.list=page.items;
            // 控制行勾选框是否可勾选：仅确认中的记录可勾选
            page.items.forEach(row => {
                row._disabled = row.logisticsConfirmStatus !== 'Confirming';
            });
            if(context.state.table.list.length>0){
                context.state.allTotal=reponse.data.result.allTotalAmount;
            }
            else{
                context.state.allTotal=null;
            }

        },
        
        //新增
        async create(context: ActionContext<LogisticsCostState, any>, payload: any) {
            await $http.post('services/app/LogisticsCost/Registration', payload.data);
        },
        //更新
        async update(context: ActionContext<LogisticsCostState, any>, payload: any) {
            await $http.put('services/app/LogisticsCost/Update', payload.data);
        },
        //删除
        async delete(context: ActionContext<LogisticsCostState, any>, payload: any) {
            await $http.delete('/services/app/LogisticsCost/Delete?Id=' + payload.data.id);
        },
        //根据id获取单个记录
        async get(context: ActionContext<LogisticsCostState, any>, payload: any) {
            
            let reponse = await $http.get('/services/app/LogisticsCost/Get?Id=' + payload.id);
            context.state.editLogisticsCost=reponse.data.result;
            return reponse.data.result as LogisticsCost;
        },
        //确认
        async confirm(context: ActionContext<LogisticsCostState, any>, payload: any) {
            await $http.post('services/app/LogisticsCost/Confirm', payload.data);
        },
        //撤销
        async revoke(context: ActionContext<LogisticsCostState, any>, payload: any) {
            await $http.post('services/app/LogisticsCost/Revoke', payload.data);
        },
        //批量确认
        async batchConfirm(context: ActionContext<LogisticsCostState, any>, payload: any) {
            await $http.post('services/app/LogisticsCost/BatchConfirm', payload.data);
        },
    };

    overrideMutations = {
        edit(state: LogisticsCostState, declareCustoms: LogisticsCost) {
            state.editLogisticsCost = declareCustoms;
        },
        setSecurityItem(state: LogisticsCostState, payload: any) {
            state.securityItem = payload.securityItem
        },
    }
}

const logisticsCostModule = new LogisticsCostModule();
export default logisticsCostModule;


